import { render, staticRenderFns } from "./CustomSelectOption.vue?vue&type=template&id=472c8f1c"
import script from "./CustomSelectOption.vue?vue&type=script&lang=js"
export * from "./CustomSelectOption.vue?vue&type=script&lang=js"
import style0 from "./CustomSelectOption.vue?vue&type=style&index=0&id=472c8f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports